import rp from "@reporting/rp-app-host";
import { dates } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { ReportContext } from "@reporting/rp-types/analytics";
import { AnalyticsApplication } from "..";

const app = () => rp.applications.get('analytics') as AnalyticsApplication;

export async function save(context: ReportContext) {
	const cmd = await rp.host.openMenu({
		value: '',
		mode: 'search',
		content: [{
			id: 'new',
			name: msg('create new view')
		}, {
			id: 'replace',
			name: msg('replace existing view')
		}]
	});

	if (cmd.id == 'new') {
		return saveNew(context);
	} else if (cmd.id == 'replace') {
		return saveReplace(context);
	}

	return false;
}

const createDefaultName = (context: ReportContext) => {
	const module = context.module ?? context.context?.module;
	const name = module == 'D' ? 'dashboard' : module == 'S' ? 'spreadsheet' : 'report';
	return `${name}-${dates.format(new Date(), 'yyyyMMdd-HHmmss')}`;
}

export async function saveNew(context: ReportContext) {
	delete context.user_name;
	const defaultName = createDefaultName(context);
	const cmd = await rp.host.openMenu({
		text: msg('Enter name for the new view'),
		value: '',
		placeholder: defaultName,
		mode: 'input',
		content: [
			{id: 'save', name: msg('Save')},
			{id: 'cancel', name: msg('Cancel')},
		]
	});

	if (cmd.id != 'save') return false;

	// empty input falls back to the default name shown as placeholder
	context.name = cmd.value?.length ? cmd.value : defaultName;

	return app().contextBroker.saveAs(context);
}

export async function saveReplace(context: ReportContext) {
	const list = await rp.ms('analytics').get<ReportContext[]>(`namedContexts`, {
		fields: ['id_context', 'name', 'date_accessed'],
		where: { module: context.context?.module || context.module },
		order: [['date_accessed', 'desc']]
	});

	if (list.length == 0) {
		rp.host.showAlert({content: msg('No existing views to replace'), type: 'warning'});
		return false;
	}

	// show the current view first (if it is among the replaceable views)
	const currentIndex = context.id_context
		? list.findIndex(item => item.id_context == context.id_context)
		: -1;
	if (currentIndex > 0) list.unshift(list.splice(currentIndex, 1)[0]);

	const cmd1 = await rp.host.openMenu({
		value: '',
		text: msg('Select view to replace'),
		mode: 'search',
		content: [
			...list.map(item => ({
				id: item.id_context.toString(),
				name: `#${item.id_context} ${item.name}`  //(${dates.format(item.date_accessed, 'yyyy-MM-dd HH:mm')})`
			}))
		]
	});

	if (!cmd1?.id) return false;

	const cmd2 = await rp.host.openMenu({
		value: '',
		text: msg('Do you want to replace view {name}?', {data: {name: cmd1.value}}),
		mode: 'search',
		content: [
			{id: 'y', name: msg('Yes')},
			{id: 'n', name: msg('No')},
		]
	});

	if (cmd2.id == 'y') {
		context.id_context = parseInt(cmd1.id);
		delete context.name;
		return app().contextBroker.save(context);
	}

	return false;
}
